// Imports 
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import React from 'react';
import { createTheme , ThemeProvider } from "@mui/material";
import CssBaseline from '@mui/material/CssBaseline';

// Pages
import Home from "./pages/Home/Home"
import Application from "./pages/Application/Application"
import CaseStudy from "./pages/CaseStudy/CaseStudy"
import Demo from "./pages/Demo/Demo"
import Media from "./pages/Media/Media"
import Login from "./pages/Login/Login"
import SignUp from "./pages/SignUp/SignUp"
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import TalkToUs from "./components/TalkToUs/TalkToUs"
import MarketingChat from "./components/MarketingChat/MarketingChat"
import { useState } from "react";



let font = localStorage.getItem("lang") === "en" ? `"Calibri", "Helvetica", "Arial", sans-serif` : 
`'SST Arabic', sans-serif`



// Theming
const theme = createTheme({
  breakpoints : {
    values : {
      xs : 0,
      sm : 768,
      md : 991,
      lg : 1280,
    }
  },
  palette : {
    primary : {
      main : "#563F79"
    },
    secondary : {
      main : "#43D2AC"
    },
    grey : {
      main : "#939393"
    }, 
    text : {
      primary : "#414141",
      secondary : "#595959",
    },
  },
  spacing : 2,
  typography : {

    "fontFamily": font,
    "fontSize": 14,
    "fontWeightLight": 300,
    "fontWeightRegular": 400,
    "fontWeightMedium": 500,
    "fontWeightBold": 700,
    
    h6 : {
      fontSize : "16px",
      fontWeight : "400",
      lineHeight : "20px"
    },
    
    button : {
      textTransform : "none",
      fontSize : "18px",
      fontWeight : "400",
      lineHeight : "22px"
    }
  }
})



function App() {

  const [active, setActive] = useState(false)
  
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <CssBaseline />
          <Router>
            <TalkToUs active2={active} setActive2={setActive}/>
            <MarketingChat />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home setActive={setActive}/>} />
              <Route path="/application" element={<Application/>} />
              <Route path="/caseStudy" element={<CaseStudy/>} />
              <Route path="/demo" element={<Demo/>} />
              <Route path="/media" element={<Media/>} />
              <Route path="/login" element={<Login/>} />
              <Route path="/sign-up" element={<SignUp />} />
            </Routes>
            <Footer />
          </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
